/**
 * Die Hilfe. Beantwortet die eine Frage, die im Gespraech mit einer Kanzlei
 * immer kommt: wie kommt die erzeugte Datei nach DATEV.
 *
 * Nur der camt-Weg, ohne Vorrede. Die MT940-Schritte stehen im
 * Exportfenster, sobald dieses Format gewaehlt ist.
 */
import { Fenster } from './Fenster'
import { DatevAnleitung } from './DatevAnleitung'

export function Hilfe({ offen, aufSchliessen }: { offen: boolean; aufSchliessen: () => void }) {
  return (
    <Fenster titel="So kommt die Datei in DATEV" offen={offen} aufSchliessen={aufSchliessen} breit>
      <div className="formular">
        <DatevAnleitung format="camt053" />

        <div className="formular-fuss">
          <button type="button" className="knopf still" onClick={aufSchliessen}>Schließen</button>
        </div>
      </div>
    </Fenster>
  )
}
